export default {
  productList: {
    title: '化学品リスト',
    description:
      '株式会社大真の主な取扱製品については、以下のリストをご参照ください。製品が見つからない場合やご不明な点がございましたら、',
    sendInquiry: 'お問い合わせ',
    descriptionSuffix: 'ください。',
    searchPlaceholder: '化学品名を入力',
    searchBtn: '化学品を検索',
    showing: '表示中',
    of: '件中',
    resultsSuffix: '件表示',
    col: {
      name: '化学品名',
      formula: '化学式 / 分子量',
      hsCode: 'HSコード',
      application: 'ご用途',
      contact: 'お問い合わせ',
    },
    askDetails: '詳細を聞く',
    noProducts: '製品が見つかりません',
    noProductsHint: '別の検索ワードまたは文字で試してください',
    clearSearch: '検索をクリア',
    footnote:
      '本ケミカルリストには、株式会社大真が取り扱う高品質な化学品およびマイナーメタルの一部を掲載しています。なお、需給状況、化学メーカーの特定国への輸出方針、その他の理由により、掲載製品であってもお見積りをご提供できない場合があります。あらかじめご了承ください。',
    cta: {
      title: 'お探しの製品が見つかりませんか？',
      description: 'ご希望の仕様を添えてお問い合わせください。お客様のニーズに合った化学品の調達をお手伝いします。',
      btn: 'お問い合わせ',
    },
  },
};
